const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },

  FormatMoney(amount) {
    let currency = Shopify.currency.active;

    // Convert to float and handle negative values
    const value = parseFloat(amount) / 100;
    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);

    // Format with proper decimal places
    const formatter = new Intl.NumberFormat(currency, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    let formattedValue = formatter.format(absoluteValue);

    if (currency === "CAD") {
      formattedValue = formattedValue.replace("CA$", "$");
    } else if (currency === "EUR") {
      formattedValue = formattedValue.replace(".", ",");
    }

    if (currency !== "USD") {
      formattedValue = `${formattedValue} ${currency}`;
    }

    return isNegative ? `-${formattedValue}` : formattedValue;
  },
};

document.addEventListener("alpine:init", () => {
  let products = [];

  Alpine.data("ProductColorSelector", () => ({
    $section: null,
    $productCard: null,
    $variantId: null,
    product: null,
    mounted() {
      let am = this;
      am.$section = am.$el;

      am.SetProduct();

      am.$section
        .querySelectorAll(".x-cloak-hidden")
        .forEach((item) => item.classList.remove("x-cloak-hidden"));
    },
    SetProduct() {
      let am = this;
      UTILS.ConvertStringToJS(
        am.$section.querySelector("[data-product-json]").innerHTML
      );
      product.color_option = product.options_with_values.find(
        (option) => option.name == "Color"
      );
      am.product = product;
      products.push(product);
    },

    e_ShowColorImage() {
      let am = this;
      // Get the selected color input that triggered the event
      let selectedColor = am.$section.querySelector(
        'input[name^="Color"]:checked'
      );
      if (!selectedColor) return;

      let colorValue = selectedColor.value;
      let matchingVariant = am.product.variants.find(
        (variant) => variant.option1 === colorValue
      );

      console.log(matchingVariant);

      if (!matchingVariant || !matchingVariant.media) return;

      // Find the closest product card to the selected color input
      let $productCard = selectedColor.closest(".product-card-wrapper");
      if (!$productCard) return;

      let $image = $productCard.querySelector(".card__media img:first-of-type");
      if (!$image) return;

      const baseUrl = "//steff-eleoff.myshopify.com/cdn/shop/"; // Replace with your actual base URL
      const imageUrl = baseUrl + matchingVariant.media.src; // Combine base URL with relative path

      $image.setAttribute("src", imageUrl);
      $image.setAttribute("srcset", `${imageUrl}?width=533`);

      const $priceRegular = $productCard.querySelector(".price__regular");
      const $priceSale = $productCard.querySelector(".price__sale");

      if (matchingVariant.compare_price) {
        const $priceRegularItem = $priceSale.querySelector(
          ".price-item--regular"
        );
        const $priceSaleItem = $priceSale.querySelector(".price-item--sale");

        if ($priceRegularItem && $priceSaleItem) {
          $priceRegularItem.innerHTML = matchingVariant.compare_price;
          $priceSaleItem.innerHTML = matchingVariant.price;
        }

        $priceRegular.style.display = "none";
        $priceSale.style.display = "block";
      } else {
        const $priceRegularItem = $priceRegular.querySelector(
          ".price-item--regular"
        );
        $priceRegularItem.innerHTML = UTILS.FormatMoney(matchingVariant.price);

        $priceRegular.style.display = "block";
        $priceSale.style.display = "none";
      }
    },
  }));
});
